import { render } from "./AddCustomField.vue?vue&type=template&id=1f181800&scoped=true"
import script from "./AddCustomField.vue?vue&type=script&lang=js"
export * from "./AddCustomField.vue?vue&type=script&lang=js"

import "./AddCustomField.vue?vue&type=style&index=0&id=1f181800&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f181800"]])

export default __exports__